import React, { FunctionComponent } from 'react';
import { StepperFormFooter } from 'mymoria-ui/components';
import { global, letter as t } from 'data';
import { Form, Formik } from 'formik';
import { LetterShippingDate } from 'mymoria-types';
import { useDispatch, useSelector } from 'hooks';
import { updateLetter } from 'actions/letters';
import { isEmpty, merge } from 'lodash';
import { Step as StepProps } from './types';
import { ShippingDateForm, shippingDateSchema } from '../forms';

const ShippingDateStep: FunctionComponent<StepProps> = ({ letterId, onClickNext, ...props }) => {
  const dispatch = useDispatch();
  const letter = useSelector(({ entities }) => entities.letters[letterId]);

  const handleSubmit = (shippingDate: LetterShippingDate) =>
    dispatch(updateLetter(letterId, { shippingDate }));

  return (
    <Formik
      initialValues={merge({}, letter.shippingDate)}
      validationSchema={shippingDateSchema}
      onSubmit={handleSubmit}
    >
      {({ dirty, isValid, submitForm, values }) => (
        <Form noValidate>
          <ShippingDateForm />
          <StepperFormFooter
            labelPrev={global.labels.back}
            labelNext={isEmpty(values) ? global.labels.skip : t.create.steps.shippingDate.submit}
            onClickNext={() => (dirty ? submitForm().then(onClickNext) : onClickNext())}
            disabledNext={!isValid}
            {...props}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ShippingDateStep;
